module.exports = __webpack_public_path__ + "static/img/RAZ-G2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-G2_1.png
// module id = k3tu
// module chunks = 0